import { useUpdatedUserImage } from '../stores'

export function useChatUserImage(userId?: string, fallbackImage?: string | null) {
  const updatedUserImage = useUpdatedUserImage(userId)

  if (updatedUserImage !== undefined) return updatedUserImage

  return fallbackImage ?? null
}
